<template>
  <b-navbar class="is-fixed-top" type="is-black" :class="{ 'navbar-home': $route.path == '/' }">
    <template slot="brand">
      <router-link to="/">
        <b-navbar-item class="is-unselectable">
          <img class="logo" src="../assets/KnockOutFC-logo.png" />
        </b-navbar-item>
      </router-link>
    </template>

    <template slot="end">
      <b-navbar-item
        class="is-hidden-desktop has-background-primary primary-btn"
        href="tel://9810074556"
      >
        <b-icon icon="phone-alt" size="is-small" class="icon-left"></b-icon>Book a Trial
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'branches' }" class="is-hoverable">
        &nbsp; Branches
        <div class="navbar-dropdown is-right is-boxed">
          <router-link to="/branches" v-for="(branch,index) in branches" :key="index">
            <a class="navbar-item">{{ branch }}</a>
          </router-link>
        </div>
      </b-navbar-item>
      <b-navbar-item tag="router-link" :to="{ name: 'classes' }" class="is-hoverable">
        &nbsp; Classes
        <div class="navbar-dropdown is-right is-boxed">
          <router-link to="/classes" v-for="(class_name,index) in classes" :key="index">
            <a class="navbar-item">{{ class_name }}</a>
          </router-link>
        </div>
      </b-navbar-item>
      <!-- <b-navbar-item tag="router-link" :to="{ name: 'teachers' }">&nbsp; Teachers</b-navbar-item> -->
      <b-navbar-item
        class="is-hidden-touch has-background-primary primary-btn"
        href="tel://9810074556"
      >
        <b-icon icon="phone-alt" size="is-small" class="icon-left"></b-icon>Book a Trial
      </b-navbar-item>
      <!-- Modal Window. Visible on-click -->
    </template>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      branches: [
        "Kalkaji",
        "Saket",
        "Malviya Nagar",
        "Gurgaon DLF 3",
        "Gurgaon Sector 58",
        "Noida Sector 76",
        "Noida Extension Gaur City",
        "Vishnu Garden ",
        "Karkardoma"
      ],
      classes: [
        "Boxing",
        "Kickboxing",
        "Muay Thai",
        // "Brazilian Jiu Jitsu",
        "Self Defense"
        // "Core & Combat",
        // "Outdoor Sessions",
        // "Strength & Conditioning"
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  background-color: rgba(0, 0, 0, 0.6) !important;
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.25);
}

// Navbar Hamburger icon color
.logo {
  -webkit-filter: brightness(0) invert(1);
  /* Safari 6.0 - 9.0 */
  filter: brightness(0) invert(1);
}

.navbar.is-light .navbar-burger {
  color: #ccc !important;
}

.navbar-item img {
  max-height: 30px !important;
  margin: 5px !important;
}

a.navbar-item:focus-within {
  background-color: transparent !important;
}

.icon {
  vertical-align: text-top;
}
</style>
